export const moneyFormatter = Intl.NumberFormat('pt-BR', {
	style: 'decimal',
	minimumFractionDigits: 2,
	maximumFractionDigits: 2,
})